var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExceedance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "27px",
    viewBox: "0 0 24 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "34B23142-12EB-44C9-95D3-F50CF7A7D688") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.4444444,9.55555556 L22.5555556,1.77777778 L3.88888889,1.77777778 C3.88888889,0.844444444 3.26666667,0.222222222 2.33333333,0.222222222 C1.4,0.222222222 0.777777778,0.844444444 0.777777778,1.77777778 L0.777777778,23.5555556 C0.777777778,24.4888889 1.4,25.1111111 2.33333333,25.1111111 C3.26666667,25.1111111 3.88888889,24.4888889 3.88888889,23.5555556 L3.88888889,17.3333333 L22.5555556,17.3333333 L19.4444444,9.55555556 Z",
    id: "path-1-exceedance"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GLOBAL---COMMUNICATIONS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communications---Dashboard---Basic",
    transform: "translate(-482.000000, -1308.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Notification-Center",
    transform: "translate(204.000000, 582.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Program-Card---CR",
    transform: "translate(0.000000, 444.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stat---Exceedance",
    transform: "translate(266.000000, 267.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle-Icon---Translucent",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(12.333333, 11.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-exceedance",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-exceedance"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-\\uD83C\\uDFA8Color",
    mask: "url(#mask-2-exceedance)",
    fill: "#EF0900"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.000000, -6.000000)",
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 37.3333333,
    height: 37.3333333
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExceedance);
export default __webpack_public_path__ + "static/media/Exceedance.19140b75.svg";
export { ForwardRef as ReactComponent };